import MMEpaperBanner from "@assets/manavar_murasu/mm_epaper_desktop.png";
import MMEpaperBannerMobile from "@assets/manavar_murasu/mm_epaper_mobile.jpg";
import MMEpaperBannerTablet from "@assets/manavar_murasu/mm_epaper_tablet.png";
import { useWindowSize } from "@hooks/useWindowSize/useWindowSize";
import { type ReactElement } from "react";

export function ManavarMurasuHeader(): ReactElement {
  const { isScreenLG, isScreenXL } = useWindowSize();

  return (
    <div className="w-full overflow-x-auto whitespace-nowrap">
      <a
        className="no-underline"
        target={isScreenLG || isScreenXL ? "_blank" : "_self"}
        href="https://e-paper.sph.com.sg/mm"
        rel="noreferrer"
      >
        <img
          className="hidden lg:block w-[100%]"
          alt="மாணவர் முரசு"
          src={MMEpaperBanner}
        />
        <img
          className="hidden lg:hidden md:block sm:block w-[100%]"
          alt="மாணவர் முரசு"
          src={MMEpaperBannerTablet}
        />
        <img
          className="block lg:hidden md:hidden sm:hidden w-[100%]"
          alt="மாணவர் முரசு"
          src={MMEpaperBannerMobile}
        />
      </a>
    </div>
  );
}
